import { ActionContext, ActionTree } from 'vuex';
import { ProductState, RootState } from '@/store/types';
import { ListParams } from '@/models/list-params';
import OrgService from '@/services/org.service';

const actions: ActionTree<ProductState, RootState> = {
  fetchProducts: (
    { commit, rootGetters }: ActionContext<ProductState, RootState>,
    queryParams: ListParams
  ): Promise<number> => {
    return OrgService.getProducts(
      rootGetters['org/getShortName'],
      queryParams
    ).then(PaginatedList => {
      commit('setProducts', PaginatedList.list);
      return PaginatedList.totalItems;
    });
  },
};

export default actions;
